import type { Reducer } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { VAUTO_TRIFORCE_SUCCESS, VAUTO_TRIFORCE_FAILURE, VAUTO_TRIFORCE_REQUEST } from '../actionTypes/vAutoTriforceActionTypes';
import type { VAutoTriforceState } from '@makemydeal/dr-dash-types';

export const vAutoTriforceInitialState: VAutoTriforceState = {};

export type vAutoTriforceReducer = Reducer<VAutoTriforceState>;

export const reducer: vAutoTriforceReducer = (state: VAutoTriforceState = vAutoTriforceInitialState, action: AnyFSA) => {
    switch (action.type) {
        case VAUTO_TRIFORCE_REQUEST: {
            const appraisal = action.meta?.appraisalId;
            return {
                ...state,
                [appraisal]: {
                    data: null,
                    hasError: false
                }
            };
        }
        case VAUTO_TRIFORCE_SUCCESS: {
            const { data, ok } = action.payload;
            const appraisal = action.meta?.appraisalId;
            if (!ok) {
                return {
                    ...state,
                    [appraisal]: {
                        data: null,
                        hasError: true
                    }
                };
            }

            return { ...state, [appraisal]: { data, hasError: false } };
        }
        case VAUTO_TRIFORCE_FAILURE: {
            const appraisal = action.meta?.appraisalId;
            return { ...state, [appraisal]: { data: null, hasError: true } };
        }

        default: {
            return state;
        }
    }
};
